import { FC, PropsWithChildren } from "react";

import { SHEET_CHILDREN_CLASS } from "./Sheet.config";

export const SheetChildren: FC<PropsWithChildren> = ({ children }) => {
  if (!children) { return null; }
  return (
    <div
      data-component="SheetChildren"
      className={SHEET_CHILDREN_CLASS}
    >
      { children }
    </div>
  );
};
